export const ASSETS = {
  logo: "/assets/logo.png",
  logoGold: "/assets/logo-gold.png",
  waterBanner: "/assets/water-banner.png",
  chipsGreen: "/assets/masala-blast-green.png",
  chipsOrange: "/assets/masala-blast-orange.png",
  snackGrid: "/assets/snack-grid.png",
};

export const CONTACT = {
  phone: "9516997799",
  email: "sales@ananyagroups.company",
  altEmail: "admin@ananyagroup.company",
  address: "Gram Kothariya, Babai — 461661",
};

const A = (name) => `/assets/${name}.png`;

export const COMPANY = {
  name: "Ananya Consumer Goods Pvt. Ltd.",
  incorporated: "24 September 2026",
  paidUpCapital: "₹5,00,000",
  msme: "UDYAM-MP-10-0184958",
};

export const VENTURES = {
  name: "M/S Ananya Ventures",
  gst: "23ACNFA3657N1ZZ",
};

export const GOLD_PRODUCTS = [
  {
    id: "gold-soap-original",
    name: "Original Germ Defence Soap",
    variant: "Bathing Bar",
    category: "personal-care",
    tag: "99.99% Germ Defence",
    description: "Over 89% naturally derived ingredients with plant-derived cleansers. IMA recommended — be 100% sure.",
    image: "/assets/gold-soap-original.jpg",
  },
  {
    id: "gold-glycerin-bars",
    name: "Original Glycerin Bar",
    variant: "8 Bars × 125 g",
    category: "personal-care",
    tag: "With Natural Oils",
    description: "Pure and gentle glow. Glycerin bathing bars with natural oils in a value 8-bar family pack.",
    image: "/assets/gold-glycerin-bars.jpg",
  },
  {
    id: "gold-handwash",
    name: "Liquid Hand Wash",
    variant: "Rose Extract Collection",
    category: "personal-care",
    tag: "Soft Smooth Skin",
    description: "Liquid hand wash soap with rose extract for soft, smooth skin — in three vibrant variants.",
    image: "/assets/gold-handwash.jpg",
  },
  {
    id: "gold-sandal-pack",
    name: "Total Skin Care Soap",
    variant: "8N × 125 g Exclusive Pack",
    category: "personal-care",
    tag: "Sandal & Turmeric",
    description: "Total skin care with sandal and turmeric — 2x better care in an exclusive value pack.",
    image: "/assets/gold-sandal-pack.jpg",
  },
  {
    id: "gold-toilet-cleaner",
    name: "Toilet Cleaner",
    variant: "500 ml",
    category: "home-care",
    tag: "10X Cleaning",
    description: "Powerful thick formula that removes tough stains, kills 99.9% germs and keeps freshness with a bright seat.",
    image: "/assets/gold-toilet-cleaner.jpg",
  },
  {
    id: "gold-soap-variants",
    name: "Beauty Soap Collection",
    variant: "White Impress · Aqua Sparkle · Soft Touch",
    category: "personal-care",
    tag: "3 Variants",
    description: "Silk-essence bathing bars for every skin need — fair & smooth, invigorated & refreshed, or noticeably soft skin.",
    image: "/assets/gold-soap-variants.jpg",
  },
  {
    id: "gold-dishwash",
    name: "Dishwash Liquid + Bar",
    variant: "Lemon Power Duo",
    category: "home-care",
    tag: "Power of Lemon",
    description: "Removes 100+ tough grease and stains, cleans brilliantly, yet stays gentle on hands with fresh lemon fragrance.",
    image: "/assets/gold-dishwash.jpg",
  },
  {
    id: "gold-detergent-powder",
    name: "Detergent Powder",
    variant: "1 kg · 2 kg · 5 kg Economy Packs",
    category: "home-care",
    tag: "Combo Pack",
    description: "Fresh lemon fragrance with brighter clothes and deep clean — tough on stains across three economy pack sizes.",
    image: "/assets/gold-detergent-powder.jpg",
  },
  {
    id: "gold-detergent-soap",
    name: "Detergent Soap Bar",
    variant: "Multi-Pack Bars",
    category: "home-care",
    tag: "New Launch",
    description: "Tough on stains, gentle on fabrics, with long-lasting freshness — the everyday laundry bar.",
    image: "/assets/gold-detergent-soap.jpg",
  },
];

export const PRODUCTS = [
  {
    id: "water-1l",
    name: "Ananya Refresh Water",
    variant: "1 Litre",
    category: "beverages",
    tag: "Best Seller",
    description: "RO-purified packaged drinking water, rich in minerals. The volume driver for every retail shelf.",
    image: A("water-1l"),
  },
  {
    id: "water-500ml",
    name: "Ananya Refresh Water",
    variant: "500 ml",
    category: "beverages",
    tag: "High Rotation",
    description: "The everyday hydration format — pure, safe and refreshing for on-the-go retail counters.",
    image: A("water-500ml"),
  },
  {
    id: "water-200ml",
    name: "Ananya Refresh Water",
    variant: "200 ml",
    category: "beverages",
    tag: "Events & Travel",
    description: "Compact format built for events, travel and high-volume catering demand.",
    image: A("water-200ml"),
  },
  {
    id: "mango-drink",
    name: "Ananya Refresh Mango Drink",
    variant: "250 ml · 600 ml · 1.2 L",
    category: "beverages",
    tag: "New Launch",
    description: "Fruit Power mango drink — rich, pulpy and refreshing, in three retail-ready pack sizes.",
    image: "/assets/mango-drink.jpg",
    fit: "cover",
  },
  {
    id: "masala-blast-kurkure",
    name: "Masala Blast Kurkure",
    variant: "₹5 Pack",
    category: "snacks",
    tag: "Signature",
    description: "Thick-cut wavy kurkure, perfectly seasoned. Salted, crispy and irresistible at the ₹5 price point.",
    image: ASSETS.chipsGreen,
  },
  {
    id: "masala-blast-chips",
    name: "Masala Blast Wavy Chips",
    variant: "₹5 Pack",
    category: "snacks",
    tag: "Signature",
    description: "Bold masala, perfect crunch. Thick-cut wavy chips engineered for repeat purchase.",
    image: ASSETS.chipsOrange,
  },
  {
    id: "khatta-mittha",
    name: "Khatta Mittha",
    variant: "₹5 Pack",
    category: "snacks",
    tag: "Classic",
    description: "Sweet and tangy delight — a perfect blend of taste with quality ingredients.",
    image: A("khatta-mittha"),
  },
  {
    id: "moong-dal",
    name: "Moong Dal",
    variant: "₹5 Pack",
    category: "snacks",
    tag: "Protein Rich",
    description: "Light, crispy and protein-rich. A trusted namkeen staple for every counter.",
    image: A("moong-dal"),
  },
  {
    id: "tasty",
    name: "Tasty Crunchy Snack",
    variant: "₹5 Pack",
    category: "snacks",
    tag: "Crowd Favourite",
    description: "Perfect blend of spices with a crunchy bite that keeps customers coming back.",
    image: A("tasty"),
  },
  {
    id: "all-in-one",
    name: "All In One Mixture",
    variant: "₹5 Pack",
    category: "snacks",
    tag: "All-Time Mix",
    description: "The all-time favourite mixture — crunchy, tasty and made with quality ingredients.",
    image: A("all-in-one"),
  },
  {
    id: "long-sav",
    name: "Long Sav",
    variant: "₹5 Pack",
    category: "snacks",
    tag: "Authentic",
    description: "Extra-long crunch with authentic taste. A traditional namkeen done right.",
    image: A("long-sav"),
  },
  {
    id: "alu-bhujiya",
    name: "Alu Bhujiya",
    variant: "₹5 Pack",
    category: "snacks",
    tag: "Desi Classic",
    description: "The desi classic flavour — crisp potato bhujiya seasoned to perfection.",
    image: A("alu-bhujiya"),
  },
  {
    id: "masala-waves",
    name: "Masala Blast Waves",
    variant: "₹5 Pack",
    category: "snacks",
    tag: "Bold Masala",
    description: "Wavy chips with a bold masala punch — thick cut, perfectly seasoned.",
    image: A("waves-red"),
  },
];
